export const removeSpecialChars = (x) => {
  return x.toString().replace(/(\r\n|\n|\r)/gm, '').replace(/'/g, '');
}

// check if the company id is in the format of exchange:ticker
export const validateCompanyyId = (companyId) => {
  const regex = /^[A-Za-z0-9.-]+:[A-Za-z0-9.-]+$/;
  return regex.test(companyId);
}